import CalendarTableSettings from '@app/model/company_hotel/settings/CalendarTableSettings';
import { GraphQLExecutor } from '@app/model/_common/service/GraphQLExecutor';
import {
	SAVE_COMPANY_HOTEL_AVAILABILITY_SETTINGS_MUTATION,
	SAVE_COMPANY_HOTEL_CALENDAR_EXPORT_SETTINGS_MUTATION,
	SAVE_COMPANY_HOTEL_CALENDAR_FILTERS_SETTINGS_MUTATION,
	SAVE_COMPANY_HOTEL_CALENDAR_SETTINGS_MUTATION,
	SAVE_COMPANY_HOTEL_CALENDAR_TABLE_SETTINGS_MUTATION,
	SAVE_COMPANY_HOTEL_GENERAL_SETTINGS_MUTATION,
	SAVE_COMPANY_HOTEL_PRICE_RECOMMENDATION_SETTINGS_MUTATION,
	SAVE_HIDDEN_PRICING_ROOM_RATE_TYPES_MUTATION,
	SAVE_COMPANY_HOTEL_PRICE_SETTINGS_MUTATION,
} from '@app/model/company_hotel/service/CompanyHotelSettingsGraphQLQueries';
import CompanyHotelSettings from '@app/model/company_hotel/settings/CompanyHotelSettings';
import CalendarFiltersSettings from '@app/model/company_hotel/settings/CalendarFiltersSettings';
import CompanyHotelGeneralSettingsInput from '@app/model/company_hotel/input/CompanyHotelGeneralSettingsInput';
import CompanyHotelCalendarSettingsInput from '@app/model/company_hotel/input/CompanyHotelCalendarSettingsInput';
import CompanyHotelPriceSettingsInput from '@app/model/company_hotel/input/CompanyHotelPriceSettingsInput';
import CompanyHotelAvailabilitySettingsInput
	from '@app/model/company_hotel/input/CompanyHotelAvailabilitySettingsInput';
import CompanyHotelPriceRecommendationSettings
	from '@app/model/company_hotel/settings/CompanyHotelPriceRecommendationSettings';
import CompanyHotelCalendarExportSettingsInput
	from '@app/model/company_hotel/input/CompanyHotelCalendarExportSettingsInput';


export class CompanyHotelSettingsService {
	public static saveCalendarTableSettings(variables: { companyHotelId: number, input: CalendarTableSettings }): Promise<CompanyHotelSettings> {
		return GraphQLExecutor.execute<CompanyHotelSettings>(SAVE_COMPANY_HOTEL_CALENDAR_TABLE_SETTINGS_MUTATION, variables);
	}

	public static saveCalendarFiltersSettings(variables: { companyHotelId: number, input: CalendarFiltersSettings }): Promise<CompanyHotelSettings> {
		return GraphQLExecutor.execute<CompanyHotelSettings>(SAVE_COMPANY_HOTEL_CALENDAR_FILTERS_SETTINGS_MUTATION, variables);
	}

	public static saveCompanyHotelGeneralSettings(variables: { companyHotelId: number, input: CompanyHotelGeneralSettingsInput}): Promise<CompanyHotelSettings> {
		return GraphQLExecutor.execute<CompanyHotelSettings>(SAVE_COMPANY_HOTEL_GENERAL_SETTINGS_MUTATION, variables);
	}

	public static saveCompanyHotelCalendarSettings(variables: { companyHotelId: number, input: CompanyHotelCalendarSettingsInput}): Promise<CompanyHotelSettings> {
		return GraphQLExecutor.execute<CompanyHotelSettings>(SAVE_COMPANY_HOTEL_CALENDAR_SETTINGS_MUTATION, variables);
	}

	public static saveCompanyHotelPriceSettings(variables: { companyHotelId: number, input: CompanyHotelPriceSettingsInput}): Promise<CompanyHotelSettings> {
		return GraphQLExecutor.execute<CompanyHotelSettings>(SAVE_COMPANY_HOTEL_PRICE_SETTINGS_MUTATION, variables);
	}

	public static saveCompanyHotelAvailabilitySettings(variables: { companyHotelId: number, input: CompanyHotelAvailabilitySettingsInput}): Promise<CompanyHotelSettings> {
		return GraphQLExecutor.execute<CompanyHotelSettings>(SAVE_COMPANY_HOTEL_AVAILABILITY_SETTINGS_MUTATION, variables);
	}

	public static saveCompanyHotelCalendarExportSettings(variables: { companyHotelId: number, input: CompanyHotelCalendarExportSettingsInput}): Promise<CompanyHotelSettings> {
		return GraphQLExecutor.execute<CompanyHotelSettings>(SAVE_COMPANY_HOTEL_CALENDAR_EXPORT_SETTINGS_MUTATION, variables);
	}

	public static saveCompanyHotelPriceRecommendationSettings(variables: { companyHotelId: number, input: {enforcePricingArchitectureHierarchy: boolean}}): Promise<CompanyHotelPriceRecommendationSettings> {
		return GraphQLExecutor.execute<CompanyHotelPriceRecommendationSettings>(SAVE_COMPANY_HOTEL_PRICE_RECOMMENDATION_SETTINGS_MUTATION, variables);
	}

	public static saveHiddenPricingRoomRateTypes(variables: { companyHotelId: number, rateTypes: string[] }): Promise<CompanyHotelPriceRecommendationSettings> {
		return GraphQLExecutor.execute<CompanyHotelPriceRecommendationSettings>(SAVE_HIDDEN_PRICING_ROOM_RATE_TYPES_MUTATION, variables);
	}

}
